import React from "react";
import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <div
      style={{
        backgroundColor: "#0a0a0a",
        color: "#eee",
        padding: "60px 20px",
        fontFamily: "'IBM Plex Sans', sans-serif",
        minHeight: "100vh",
      }}
    >
      <div style={{ maxWidth: "800px", margin: "0 auto" }}>
        <h1
          style={{
            color: "#ff77cc",
            textShadow: "0 0 8px rgba(255, 0, 170, 0.5)",
            marginBottom: "20px",
          }}
        >
          🔒 Privacy Policy
        </h1>

        <p style={{ color: "#ccc", marginBottom: "20px", fontSize: "15px" }}>
          Your privacy matters to us. Here's what you should know about how we handle your data.
        </p>

        <h3 style={{ color: "#ff99cc" }}>1. What We Collect</h3>
        <p style={{ color: "#bbb", marginBottom: "16px" }}>
          When you participate in tile reveals or submit your email via our form, we may collect basic personal information like your email address.
        </p>

        <h3 style={{ color: "#ff99cc" }}>2. How We Use Your Information</h3>
        <p style={{ color: "#bbb", marginBottom: "16px" }}>
          Your email may be used to notify you about milestones, upcoming reveals, and exclusive updates. We do not sell your data.
        </p>

        <h3 style={{ color: "#ff99cc" }}>3. Third-Party Services</h3>
        <p style={{ color: "#bbb", marginBottom: "16px" }}>
          We use Google Forms to collect email addresses, and Stripe to process payments. These services have their own privacy policies.
        </p>

        <h3 style={{ color: "#ff99cc" }}>4. Your Consent</h3>
        <p style={{ color: "#bbb", marginBottom: "16px" }}>
          By using this site, you agree to the terms outlined in this policy.
        </p>

        <h3 style={{ color: "#ff99cc" }}>5. Contact Us</h3>
        <p style={{ color: "#bbb", marginBottom: "32px" }}>
          For questions, email us at: <a href="mailto:findmyfaceproject@gmail.com" style={{ color: "#ff99cc" }}>findmyfaceproject@gmail.com</a>
        </p>

        <Link to="/" style={{ color: "#ff77cc", textDecoration: "underline" }}>
          ← Back to Home
        </Link>
      </div>
    </div>
  );
}
